import React from "react";
import { LegalLayout, LegalSection } from "./LegalLayout";

export const Widerruf = () => (
  <LegalLayout
    eyebrow="Rechtliches"
    title="Widerrufsbelehrung"
    testId="widerruf-page"
  >
    <LegalSection title="Widerrufsrecht">
      <p>
        Verbraucher haben das Recht, binnen vierzehn Tagen ohne Angabe von
        Gründen diesen Vertrag zu widerrufen.
      </p>
      <p>
        Die Widerrufsfrist beträgt vierzehn Tage ab dem Tag, an dem Sie oder
        ein von Ihnen benannter Dritter, der nicht der Beförderer ist, die
        Ware in Besitz genommen haben.
      </p>
      <p>Um Ihr Widerrufsrecht auszuüben, müssen Sie uns:</p>
      <p>
        Pflegeheld Handels GmbH
        <br />
        Bahnhofstraße 71
        <br />
        31515 Wunstorf
        <br />
        Deutschland
        <br />
        E-Mail:{" "}
        <a
          href="mailto:info@pflege-box-gratis.de"
          className="text-[#3FA66D] hover:underline break-all"
        >
          info@pflege-box-gratis.de
        </a>
      </p>
      <p>
        mittels einer eindeutigen Erklärung (z. B. ein mit der Post versandter
        Brief oder eine E-Mail) über Ihren Entschluss, diesen Vertrag zu
        widerrufen, informieren.
      </p>
      <p>
        Zur Wahrung der Widerrufsfrist reicht es aus, dass Sie die Mitteilung
        über die Ausübung des Widerrufsrechts vor Ablauf der Widerrufsfrist
        absenden.
      </p>
    </LegalSection>

    <LegalSection title="Folgen des Widerrufs">
      <p>
        Wenn Sie diesen Vertrag widerrufen, haben wir Ihnen alle Zahlungen, die
        wir von Ihnen erhalten haben, einschließlich der Lieferkosten (mit
        Ausnahme der zusätzlichen Kosten, die sich daraus ergeben, dass Sie
        eine andere Art der Lieferung als die von uns angebotene, günstigste
        Standardlieferung gewählt haben), unverzüglich und spätestens binnen
        vierzehn Tagen ab dem Tag zurückzuzahlen, an dem die Mitteilung über
        Ihren Widerruf dieses Vertrags bei uns eingegangen ist.
      </p>
      <p>
        Für diese Rückzahlung verwenden wir dasselbe Zahlungsmittel, das Sie
        bei der ursprünglichen Transaktion eingesetzt haben, es sei denn, mit
        Ihnen wurde ausdrücklich etwas anderes vereinbart; in keinem Fall
        werden Ihnen wegen dieser Rückzahlung Entgelte berechnet.
      </p>
      <p>
        Wir können die Rückzahlung verweigern, bis wir die Waren wieder
        zurückerhalten haben oder bis Sie den Nachweis erbracht haben, dass
        Sie die Waren zurückgesandt haben, je nachdem, welches der frühere
        Zeitpunkt ist.
      </p>
      <p>
        Sie tragen die unmittelbaren Kosten der Rücksendung der Waren. Sie
        müssen für einen etwaigen Wertverlust der Waren nur aufkommen, wenn
        dieser Wertverlust auf einen zur Prüfung der Beschaffenheit,
        Eigenschaften und Funktionsweise der Waren nicht notwendigen Umgang
        mit ihnen zurückzuführen ist.
      </p>
    </LegalSection>

    <LegalSection title="Ausschluss des Widerrufsrechts">
      <p>
        Das Widerrufsrecht besteht nicht bzw. erlischt bei Verträgen zur
        Lieferung versiegelter Waren, die aus Gründen des Gesundheitsschutzes
        oder der Hygiene nicht zur Rückgabe geeignet sind, wenn ihre
        Versiegelung nach der Lieferung entfernt wurde.
      </p>
    </LegalSection>
  </LegalLayout>
);

export default Widerruf;
